export default {"src":"/_next/static/media/three_dots.d2a1851c.svg","height":20,"width":5,"blurWidth":0,"blurHeight":0};